<div class="overlay-inner-wrapper">
  <div id="measurementWrapper">
    <header class="header-2" style="margin-left: -15px; margin-top: -15px; margin-right: -15px">
      <div class="branding">
        <span class="title">{{ 'Messungen' | mrTranslate }} • {{ objektname }}</span>
      </div>
      <div class="header-actions">
        <clr-checkbox-container style="margin-top: 17px; padding-right: 10px">
          <clr-checkbox-wrapper>
            <input
              type="checkbox"
              clrToggle
              name="options"
              value="false"
              [(ngModel)]="bauwerkeactive"
              (ngModelChange)="toggleBauwerke($event)" />
            <label style="color: white">{{ 'Bauwerke anzeigen' | mrTranslate }}</label>
          </clr-checkbox-wrapper>
        </clr-checkbox-container>
        <clr-checkbox-container style="margin-top: 17px; padding-right: 10px">
          <clr-checkbox-wrapper>
            <input type="checkbox" clrToggle name="options" value="false" [(ngModel)]="draganddropactive" />
            <label style="color: white">{{ 'Diagramm-Reihenfolge ändern' | mrTranslate }}</label>
          </clr-checkbox-wrapper>
        </clr-checkbox-container>
        @if (tblPruefids) {
          <div style="margin-top: -10px">
            <clr-combobox-container>
              <clr-combobox
                [(ngModel)]="selection"
                name="multiSelect"
                clrMulti="true"
                (clrOpenChange)="selChanged($event)"
                (clrOpenChange)="selOpenChanged($event)"
                (clrSelectionChange)="selChanged($event)">
                <ng-container *clrOptionSelected="let selected">{{ selected?.Datum }}</ng-container>
                <clr-options>
                  <clr-option *clrOptionItems="let id of tblPruefids.rows; field: 'Datum'" [clrValue]="id">
                    {{ id.Datum }}
                  </clr-option>
                </clr-options>
              </clr-combobox>
            </clr-combobox-container>
          </div>
        }

        <clr-dropdown>
          <button class="nav-icon" clrDropdownTrigger aria-label="toggle settings menu">
            <cds-icon shape="cog" />
          </button>
          <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
            <a (click)="getGrenzwertverletzung()" clrDropdownItem>
              {{ 'suche nach Grenzwertverletzungen' | mrTranslate }}
            </a>
            <a (click)="getMesswerte()" clrDropdownItem>{{ 'zeige Messwerte' | mrTranslate }}</a>
          </clr-dropdown-menu>
        </clr-dropdown>

        @if (isChanged) {
          <a href="javascript://" class="nav-link nav-icon">
            <cds-icon shape="floppy" (click)="saveChanges()" />
          </a>
        }

        <a href="javascript://" class="nav-link nav-icon">
          <cds-icon shape="times" (click)="close()" />
        </a>
      </div>
    </header>

    <div class="clr-row" dndDropzone (dndDrop)="onDrop($event)" dndEffectAllowed="move" [dndHorizontal]="false">
      <div dndPlaceholderRef class="card dndPlaceholder" [style.height.px]="placeHolderHeight"></div>
      @for (gr of graph.data; track gr; let ind = $index) {
        @if (gr.yData && gr.yData.length > 0) {
          <div
            class="card"
            [dndDraggable]="gr"
            [dndEffectAllowed]="'move'"
            [dndDisableIf]="!draganddropactive"
            (dndStart)="onDragStart($event)">
            <div class="card-header" [ngClass]="{ 'cursor-grab': draganddropactive }" style="padding: 0">
              <div class="clr-row" style="margin-top: 15px">
                <div class="clr-col-6">
                  <div class="clr-row">
                    <div class="clr-col-4">
                      <cds-icon
                        shape="angle"
                        size="25"
                        (click)="gr.show = !gr.show"
                        [direction]="gr.show ? 'up' : 'down'"
                        style="cursor: pointer; margin-left: -15px; margin-right: 8px"></cds-icon>
                      {{ gr.name | mrTranslate }}
                    </div>
                    <div class="clr-col-8">
                      @if (gr.key == 'Rille_L' || gr.key == 'Rille') {
                        <clr-checkbox-wrapper>
                          &nbsp;|&nbsp;
                          <input type="checkbox" clrToggle name="options" value="false" [(ngModel)]="combineRille" />
                          <label>{{ 'Rillen-Diagramme zusammenfassen' | mrTranslate }}</label>
                        </clr-checkbox-wrapper>
                      }
                    </div>
                  </div>
                </div>
                <div class="clr-col-6" style="text-align: right">
                  <button class="btn btn-icon" (click)="loadDetailView(gr)" style="margin-top: -5px">
                    <cds-icon shape="search" />
                  </button>
                  <clr-signpost>
                    <cds-icon shape="cog" solid="true" clrSignpostTrigger style="margin-top: -10px"></cds-icon>
                    <clr-signpost-content [clrPosition]="'left-bottom'" *clrIfOpen>
                      <form clrForm>
                        <clr-input-container style="margin-top: 10px">
                          <label>{{ 'Y-Max' | mrTranslate }}</label>
                          <input clrInput placeholder="Y-Max" name="ymax" [(ngModel)]="gr.layout.yaxis.range[1]" />
                        </clr-input-container>
                        <clr-input-container>
                          <label>{{ 'Y-Min' | mrTranslate }}</label>
                          <input clrInput placeholder="Y-Min" name="ymin" [(ngModel)]="gr.layout.yaxis.range[0]" />
                        </clr-input-container>
                        <button class="btn btn-primary btn-sm" style="margin-top: 1.2rem" (click)="applyYaxis(gr.key)">
                          {{ 'übernehmen' | mrTranslate }}
                        </button>
                        @if (gr.key == 'Ueberhoehung' || gr.key == 'Bogen') {
                          <clr-dropdown>
                            <button class="btn btn-outline-primary btn-sm" clrDropdownTrigger style="margin-top: 20px">
                              {{ 'Messung Y-spiegeln' | mrTranslate }}
                              <clr-icon shape="angle" direction="down"></clr-icon>
                            </button>
                            <clr-dropdown-menu clrPosition="bottom-left" *clrIfOpen>
                              <button
                                clrDropdownItem
                                *ngFor="let id of selection"
                                (click)="onMessungYSpiegeln(id, gr.key)">
                                {{ id.Datum }}
                              </button>
                            </clr-dropdown-menu>
                          </clr-dropdown>
                        }
                      </form>
                    </clr-signpost-content>
                  </clr-signpost>
                  @if (!gr.fullsize || gr.fullsize == false) {
                    <a href="javascript://" class="nav-link nav-icon">
                      <cds-icon
                        shape="resize"
                        solid="true"
                        (click)="resize(gr)"
                        style="margin-top: -10px; margin-left: 5px" />
                    </a>
                  }
                  @if (gr.fullsize || gr.fullsize == true) {
                    <a href="javascript://" class="nav-link nav-icon">
                      <cds-icon
                        shape="shrink"
                        solid="true"
                        (click)="shrink(gr)"
                        style="margin-top: -10px; margin-left: 5px" />
                    </a>
                  }
                </div>
              </div>
            </div>
            @if (gr.show) {
              <div class="card-block">
                <div style="width: 100%">
                  <div class="clr-col-12">
                    <div [ngStyle]="{ 'height.px': gr.layout.height }">
                      <app-plotly-plot-lokal
                        #plotCmp
                        [id]="gr.key"
                        [className]=""
                        [data]="gr.yData"
                        [layout]="gr.layout ? gr.layout : graph.layout"
                        [config]="graph.config"></app-plotly-plot-lokal>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>

  <!-- MODAL DETAILANSICHT -->
  <clr-modal [(clrModalOpen)]="isDetailViewVisible" [clrModalSize]="'full-screen'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Detailansicht' | mrTranslate }}</h3>
    @if (curGraph) {
      <div class="modal-body">
        <!-- Graph -->
        @if (curGraph.yData && curGraph.yData.length > 0) {
          <div class="card">
            <div class="card-block">
              <div style="width: 100%">
                <div class="clr-col-12">
                  <div style="height: 37vh; position: relative">
                    <div id="plotly_Sub"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <!-- Karte -->
        <div style="width: 100%; height: 34vh; position: relative">
          <div style="margin-top: 10px; margin-left: 5px; position: absolute; z-index: 2">
            <clr-dropdown>
              <button type="button" class="btn btn-success dropdown-toggle" action="solid" clrDropdownTrigger>
                <cds-icon shape="world" size="26" />
                <cds-icon shape="angle" direction="down" />
              </button>
              <clr-dropdown-menu *clrIfOpen>
                <a (click)="tileSwitch('sonstige', 'leer')" clrDropdownItem>{{ 'leer' | mrTranslate }}</a>
                <clr-dropdown>
                  <button clrDropdownTrigger>Bing</button>
                  <clr-dropdown-menu *clrIfOpen>
                    <clr-dropdown>
                      <a (click)="tileSwitch('bing', 'bingRoadOnDemand')" clrDropdownItem>BingMaps</a>
                      <a (click)="tileSwitch('bing', 'bingAerial')" clrDropdownItem>Sattelit</a>
                      <a (click)="tileSwitch('bing', 'bingAerialWithLabels')" clrDropdownItem>Hybrid</a>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <clr-dropdown>
                  <button clrDropdownTrigger>Carto DB</button>
                  <clr-dropdown-menu *clrIfOpen>
                    <clr-dropdown>
                      <a (click)="tileSwitch('cartoDB', 'cartoDbDark')" clrDropdownItem>Dark</a>
                      <a (click)="tileSwitch('cartoDB', 'cartoDbDarkNoLabels')" clrDropdownItem>Dark no Label</a>
                      <a (click)="tileSwitch('cartoDB', 'cartoDbLight')" clrDropdownItem>Light</a>
                      <a (click)="tileSwitch('cartoDB', 'cartoDbLightNoLabels')" clrDropdownItem>Light no Label</a>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <clr-dropdown>
                  <button clrDropdownTrigger>ESRI</button>
                  <clr-dropdown-menu *clrIfOpen>
                    <clr-dropdown>
                      <a (click)="tileSwitch('sonstige', 'esri')" clrDropdownItem>Hybrid</a>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <clr-dropdown>
                  <button clrDropdownTrigger>{{ 'Geoportale' | mrTranslate }}</button>
                  <clr-dropdown-menu *clrIfOpen>
                    <clr-dropdown>
                      <button clrDropdownTrigger>{{ 'Belgien' | mrTranslate }}</button>
                      <clr-dropdown-menu *clrIfOpen>
                        <clr-dropdown>
                          <a (click)="tileSwitch('sonstige', 'belgiumOrtho')" clrDropdownItem>Ortho</a>
                          <a (click)="tileSwitch('sonstige', 'belgiumCarto')" clrDropdownItem>Carto.be</a>
                        </clr-dropdown>
                      </clr-dropdown-menu>
                    </clr-dropdown>
                    <clr-dropdown>
                      <button clrDropdownTrigger>{{ 'Deutschland' | mrTranslate }}</button>
                      <clr-dropdown-menu *clrIfOpen>
                        <clr-dropdown>
                          <a (click)="tileSwitch('sonstige', 'bb_house')" clrDropdownItem>
                            {{ 'BB ALKIS Gebäude' | mrTranslate }}
                          </a>
                          <a (click)="tileSwitch('sonstige', 'bb_lands')" clrDropdownItem>
                            {{ 'BB ALKIS Flurstücke' | mrTranslate }}
                          </a>
                          <a (click)="tileSwitch('sonstige', 'bb_ortho')" clrDropdownItem>BB Ortho</a>
                          <a (click)="tileSwitch('sonstige', 'he_ortho')" clrDropdownItem>HE Ortho</a>
                          <a (click)="tileSwitch('sonstige', 'mv_house')" clrDropdownItem>
                            {{ 'MV ALKIS Gebäude' | mrTranslate }}
                          </a>
                          <a (click)="tileSwitch('sonstige', 'mv_lands')" clrDropdownItem>
                            {{ 'MV ALKIS Flurstücke' | mrTranslate }}
                          </a>
                          <a (click)="tileSwitch('sonstige', 'mv_ortho')" clrDropdownItem>MV Ortho</a>
                          <a (click)="tileSwitch('sonstige', 'ni_ortho')" clrDropdownItem>NI Ortho</a>
                          <a (click)="tileSwitch('sonstige', 'nrw_house')" clrDropdownItem>
                            {{ 'NR ALKIS Gebäude' | mrTranslate }}
                          </a>
                          <a (click)="tileSwitch('sonstige', 'nrw_lands')" clrDropdownItem>
                            {{ 'NR ALKIS Flurstücke' | mrTranslate }}
                          </a>
                          <a (click)="tileSwitch('sonstige', 'nrwOrtho')" clrDropdownItem>NR Ortho</a>
                          <a (click)="tileSwitch('sonstige', 'sa_ortho')" clrDropdownItem>SA Ortho</a>
                          <a (click)="tileSwitch('sonstige', 'sn_house')" clrDropdownItem>
                            {{ 'SN ALKIS Gebäude' | mrTranslate }}
                          </a>
                          <a (click)="tileSwitch('sonstige', 'sn_lands')" clrDropdownItem>
                            {{ 'SN ALKIS Flurstücke' | mrTranslate }}
                          </a>
                          <a (click)="tileSwitch('sonstige', 'sn_ortho')" clrDropdownItem>SN Ortho</a>
                          <a (click)="tileSwitch('sonstige', 'th_ortho')" clrDropdownItem>TH Ortho</a>
                          <a (click)="tileSwitch('sonstige', 'de_farbe')" clrDropdownItem>
                            {{ 'BASEMAP.DE' | mrTranslate }}
                          </a>
                          <a (click)="tileSwitch('sonstige', 'de_grau')" clrDropdownItem>
                            {{ 'BASEMAP.DE grau' | mrTranslate }}
                          </a>
                        </clr-dropdown>
                      </clr-dropdown-menu>
                    </clr-dropdown>
                    <clr-dropdown>
                      <button clrDropdownTrigger>{{ 'Luxemburg' | mrTranslate }}</button>
                      <clr-dropdown-menu *clrIfOpen>
                        <clr-dropdown>
                          <a (click)="tileSwitch('sonstige', 'luxBaseMap')" clrDropdownItem>Basemap</a>
                          <a (click)="tileSwitch('sonstige', 'luxOrtho')" clrDropdownItem>Ortho</a>
                        </clr-dropdown>
                      </clr-dropdown-menu>
                    </clr-dropdown>
                    <clr-dropdown>
                      <button clrDropdownTrigger>{{ 'Österreich' | mrTranslate }}</button>
                      <clr-dropdown-menu *clrIfOpen>
                        <clr-dropdown>
                          <a (click)="tileSwitch('sonstige', 'austriaOrtho')" clrDropdownItem>
                            {{ 'Österreich Ortho' | mrTranslate }}
                          </a>
                          <!-- <a clrDropdownItem>Voralberg Ortho</a> -->
                        </clr-dropdown>
                      </clr-dropdown-menu>
                    </clr-dropdown>
                    <clr-dropdown>
                      <button clrDropdownTrigger>{{ 'Schweiz' | mrTranslate }}</button>
                      <clr-dropdown-menu *clrIfOpen>
                        <clr-dropdown>
                          <a (click)="tileSwitch('sonstige', 'ch_base')" clrDropdownItem>
                            {{ 'Swisstopo Pixelkarte farbe' | mrTranslate }}
                          </a>
                          <a (click)="tileSwitch('sonstige', 'ch_base_grau')" clrDropdownItem>
                            {{ 'Swisstopo Pixelkarte grau' | mrTranslate }}
                          </a>
                          <a (click)="tileSwitch('sonstige', 'ch_ortho')" clrDropdownItem>Swisstopo Ortho</a>
                        </clr-dropdown>
                      </clr-dropdown-menu>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <clr-dropdown>
                  <button clrDropdownTrigger>Google</button>
                  <clr-dropdown-menu *clrIfOpen>
                    <clr-dropdown>
                      <a (click)="tileSwitch('google', 'googleMaps')" clrDropdownItem>GoogleMaps</a>
                      <a (click)="tileSwitch('google', 'googleSatellite')" clrDropdownItem>
                        {{ 'Satellit' | mrTranslate }}
                      </a>
                      <a (click)="tileSwitch('google', 'googleHybrid')" clrDropdownItem>Hybrid</a>
                      <a (click)="tileSwitch('google', 'googleTerrain')" clrDropdownItem>Terrain</a>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <clr-dropdown>
                  <button clrDropdownTrigger>Openstreetmap</button>
                  <clr-dropdown-menu *clrIfOpen>
                    <clr-dropdown>
                      <a (click)="tileSwitch('sonstige', 'osmde')" clrDropdownItem>Openstreetmap</a>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <a (click)="tileSwitch('sonstige', 'wikimedia')" clrDropdownItem>WikiMaps</a>
              </clr-dropdown-menu>
            </clr-dropdown>
          </div>
          <div id="previewMap" style="width: 100%; height: 100%; z-index: 1"></div>
        </div>
      </div>
    }
    <div class="modal-footer">
      <!-- <button type="button" class="btn btn-primary" (click)="createMapSet()">{{'OK' | mrTranslate}}</button> -->
      <button type="button" class="btn" (click)="closeModal()">{{ 'Schließen' | mrTranslate }}</button>
    </div>
  </clr-modal>
</div>

<clr-modal [(clrModalOpen)]="showverletzung" [clrModalSize]="'lg'">
  <h3 class="modal-title">{{ 'Grenzwertverletzungen' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm>
      <div class="limit-height">
        <clr-datagrid class="datagrid-compact">
          <clr-dg-column>{{ 'Startposition' | mrTranslate }}</clr-dg-column>
          <clr-dg-column>{{ 'Endposition' | mrTranslate }}</clr-dg-column>
          <clr-dg-column>{{ 'Ausfall' | mrTranslate }}</clr-dg-column>
          <clr-dg-column>{{ 'Min/Max' | mrTranslate }}</clr-dg-column>
          @for (ver of verletzung; track ver; let i = $index) {
            <clr-dg-row>
              <clr-dg-cell>{{ ver.Startposition }}</clr-dg-cell>
              <clr-dg-cell>{{ ver.Endposition }}</clr-dg-cell>
              <clr-dg-cell>{{ ver.Ausfall }}</clr-dg-cell>
              <clr-dg-cell>{{ ver.MinMax }}</clr-dg-cell>
            </clr-dg-row>
          }
          <clr-dg-footer>{{ 'Anzahl' | mrTranslate }}: {{ verletzung.length }}</clr-dg-footer>
        </clr-datagrid>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="showverletzung = false">
      {{ 'Schließen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="showmesswerte" [clrModalSize]="'xl'">
  <h3 class="modal-title">{{ 'Messwerte' | mrTranslate }} - {{ objektname }}</h3>
  <div class="modal-body">
    <form clrForm>
      @if (curMessung && curMessung.m && curMessung.m.length > 0) {
        <div class="limit-height1">
          <clr-datagrid class="datagrid-compact">
            <clr-dg-column>{{ 'm' | mrTranslate }}</clr-dg-column>
            @if (curMessung.Bogen) {
              <clr-dg-column>{{ 'Bogen' | mrTranslate }}</clr-dg-column>
            }
            @if (curMessung.Radius && curMessung.Bogen) {
              <clr-dg-column>{{ 'Radius' | mrTranslate }}</clr-dg-column>
            }
            <clr-dg-column>{{ 'Spur' | mrTranslate }}</clr-dg-column>
            @if (curMessung.Ueberhoehung) {
              <clr-dg-column>{{ 'Überhöhung' | mrTranslate }}</clr-dg-column>
            }
            @if (curMessung.Tiefpunkt) {
              <clr-dg-column>{{ 'Tiefpunkt' | mrTranslate }}</clr-dg-column>
            }
            <clr-dg-column>{{ 'Verwindung' | mrTranslate }}</clr-dg-column>

            @if (curMessung.Rille_L) {
              <clr-dg-column>{{ 'Rille links' | mrTranslate }}</clr-dg-column>
            }
            @if (curMessung.Rille_R) {
              <clr-dg-column>{{ 'Rille rechts' | mrTranslate }}</clr-dg-column>
            }

            @for (m of curMessung.m; track $index; let i = $index) {
              @if (authService?.token?.rights?.status > 4) {
                <clr-dg-row>
                  <clr-dg-cell>{{ curMessung.m[i] }}</clr-dg-cell>
                  @if (curMessung.Bogen) {
                    <clr-dg-cell class="interactive-cell" (click)="startEdit(i, 'Bogen')">
                      <div class="cell-container">
                        @if (editingCell?.rowIndex === i && editingCell?.colName === 'Bogen') {
                          <input
                            type="number"
                            step="any"
                            name="bogen_{{ i }}"
                            [ngModel]="curMessung.Bogen[i]"
                            (ngModelChange)="curMessung.Bogen[i] = $event !== null && $event !== '' ? +$event : 0"
                            (blur)="stopEdit()"
                            class="clr-input edit-input"
                            autofocus />
                        } @else {
                          <span>{{ curMessung.Bogen[i] }}</span>
                        }
                      </div>
                    </clr-dg-cell>
                  }
                  @if (curMessung.Radius && curMessung.Bogen) {
                    <clr-dg-cell>{{ curMessung.Radius[i] }}</clr-dg-cell>
                  }
                  <clr-dg-cell class="interactive-cell" (click)="startEdit(i, 'Spur')">
                    <div class="cell-container">
                      @if (editingCell?.rowIndex === i && editingCell?.colName === 'Spur') {
                        <input
                          type="number"
                          step="any"
                          name="spur_{{ i }}"
                          [ngModel]="curMessung.Spur[i]"
                          (ngModelChange)="curMessung.Spur[i] = $event !== null && $event !== '' ? +$event : 0"
                          (blur)="stopEdit()"
                          (keyup.enter)="stopEdit()"
                          class="clr-input edit-input"
                          autofocus />
                      } @else {
                        <span>{{ curMessung.Spur[i] }}</span>
                      }
                    </div>
                  </clr-dg-cell>
                  @if (curMessung.Ueberhoehung) {
                    <clr-dg-cell class="interactive-cell" (click)="startEdit(i, 'Ueberhoehung')">
                      <div class="cell-container">
                        @if (editingCell?.rowIndex === i && editingCell?.colName === 'Ueberhoehung') {
                          <input
                            type="number"
                            step="any"
                            name="ueberhoehung_{{ i }}"
                            [ngModel]="curMessung.Ueberhoehung[i]"
                            (ngModelChange)="
                              curMessung.Ueberhoehung[i] = $event !== null && $event !== '' ? +$event : 0
                            "
                            (blur)="stopEdit()"
                            (keyup.enter)="stopEdit()"
                            class="clr-input edit-input"
                            autofocus />
                        } @else {
                          <span>{{ curMessung.Ueberhoehung[i] }}</span>
                        }
                      </div>
                    </clr-dg-cell>
                  }
                  @if (curMessung.Tiefpunkt) {
                    <clr-dg-cell class="interactive-cell" (click)="startEdit(i, 'Tiefpunkt')">
                      <div class="cell-container">
                        @if (editingCell?.rowIndex === i && editingCell?.colName === 'Tiefpunkt') {
                          <input
                            type="number"
                            step="any"
                            name="tiefpunkt_{{ i }}"
                            [ngModel]="curMessung.Tiefpunkt[i]"
                            (ngModelChange)="curMessung.Tiefpunkt[i] = $event !== null && $event !== '' ? +$event : 0"
                            (blur)="stopEdit()"
                            (keyup.enter)="stopEdit()"
                            class="clr-input edit-input"
                            autofocus />
                        } @else {
                          <span>{{ curMessung.Tiefpunkt[i] }}</span>
                        }
                      </div>
                    </clr-dg-cell>
                  }
                  <clr-dg-cell class="interactive-cell" (click)="startEdit(i, 'Verwindung1')">
                    <div class="cell-container">
                      @if (editingCell?.rowIndex === i && editingCell?.colName === 'Verwindung1') {
                        <input
                          type="number"
                          step="any"
                          name="verwindung_{{ i }}"
                          [ngModel]="curMessung.Verwindung1[i]"
                          (ngModelChange)="curMessung.Verwindung1[i] = $event !== null && $event !== '' ? +$event : 0"
                          (blur)="stopEdit()"
                          (keyup.enter)="stopEdit()"
                          class="clr-input edit-input"
                          autofocus />
                      } @else {
                        <span>{{ curMessung.Verwindung1[i] }}</span>
                      }
                    </div>
                  </clr-dg-cell>

                  @if (curMessung.Rille_L) {
                    <clr-dg-cell class="interactive-cell" (click)="startEdit(i, 'Rille_L')">
                      <div class="cell-container">
                        @if (editingCell?.rowIndex === i && editingCell?.colName === 'Rille_L') {
                          <input
                            type="number"
                            step="any"
                            [(ngModel)]="curMessung.Rille_L[i]"
                            (blur)="stopEdit()"
                            (keyup.enter)="stopEdit()"
                            class="clr-input edit-input"
                            autofocus />
                        } @else {
                          <span>{{ curMessung.Rille_L[i] }}</span>
                        }
                      </div>
                    </clr-dg-cell>
                  }

                  @if (curMessung.Rille_R) {
                    <clr-dg-cell class="interactive-cell" (click)="startEdit(i, 'Rille_R')">
                      <div class="cell-container">
                        @if (editingCell?.rowIndex === i && editingCell?.colName === 'Rille_R') {
                          <input
                            type="number"
                            step="any"
                            [(ngModel)]="curMessung.Rille_R[i]"
                            (blur)="stopEdit()"
                            (keyup.enter)="stopEdit()"
                            class="clr-input edit-input"
                            autofocus />
                        } @else {
                          <span>{{ curMessung.Rille_R[i] }}</span>
                        }
                      </div>
                    </clr-dg-cell>
                  }
                </clr-dg-row>
              } @else {
                <clr-dg-row>
                  <clr-dg-cell>{{ curMessung.m[i] }}</clr-dg-cell>
                  <clr-dg-cell>{{ curMessung.Bogen[i] }}</clr-dg-cell>
                  <clr-dg-cell>{{ curMessung.Radius[i] }}</clr-dg-cell>
                  <clr-dg-cell>{{ curMessung.Spur[i] }}</clr-dg-cell>
                  <clr-dg-cell>{{ curMessung.Ueberhoehung[i] }}</clr-dg-cell>
                  <clr-dg-cell>{{ curMessung.Tiefpunkt[i] }}</clr-dg-cell>
                  <clr-dg-cell>{{ curMessung.Verwindung1[i] }}</clr-dg-cell>
                  @if (curMessung.Rille_L) {
                    <clr-dg-cell>{{ curMessung.Rille_L[i] }}</clr-dg-cell>
                  }
                  @if (curMessung.Rille_R) {
                    <clr-dg-cell>{{ curMessung.Rille_R[i] }}</clr-dg-cell>
                  }
                </clr-dg-row>
              }
            }

            <clr-dg-footer>{{ 'Anzahl' | mrTranslate }}: {{ curMessung.length }}</clr-dg-footer>
          </clr-datagrid>
        </div>
      }
    </form>
  </div>
  <div class="modal-footer">
    @if (authService?.token?.rights?.status > 4) {
      <!-- Left -->
      <div style="display: flex; align-items: center; gap: 8px; margin-right: auto">
        <clr-select-container style="margin-top: 0px">
          <select clrSelect [(ngModel)]="selectedValue" name="selectedValue">
            <option *ngFor="let item of exportOptions" [ngValue]="item.value">
              {{ item.label }}
            </option>
          </select>
        </clr-select-container>

        <clr-input-container style="margin-top: 0px">
          <input clrInput type="number" [(ngModel)]="myNumber" name="myNumber" step="0.1" min="-10" max="10" />
        </clr-input-container>

        <button type="button" class="btn btn-primary" (click)="onOffset()">Offset</button>
      </div>

      <input #fileInput type="file" accept=".xlsx" hidden (change)="onFileSelected($event)" />

      @if (isExcelExportEnabled == true) {
        <button type="button" class="btn btn-primary" (click)="fileInput.click()">
          {{ 'Excel importieren' | mrTranslate }}
        </button>
      }
    }
    <button type="button" class="btn btn-primary" (click)="doExcelExport()">{{ 'Excel export' | mrTranslate }}</button>
    <button type="button" class="btn btn-primary" (click)="showmesswerte = false">
      {{ 'Schließen' | mrTranslate }}
    </button>
  </div>
</clr-modal>
